export type LickFrame = {
  remainingScoops: number;
  contact: boolean;
  durationMs: number;
};

const MAX_VISIBLE_SCOOPS = 3;

/** Visible, deterministic mouth-contact choreography for a held order. */
export function buildLickSequence(scoopCount: number): LickFrame[] {
  const count = Math.max(
    0,
    Math.min(MAX_VISIBLE_SCOOPS, Math.floor(Number.isFinite(scoopCount) ? scoopCount : 0)),
  );
  if (count === 0) {
    return [{ remainingScoops: 0, contact: false, durationMs: 0 }];
  }

  const frames: LickFrame[] = [
    { remainingScoops: count, contact: false, durationMs: 180 },
  ];
  for (let remaining = count - 1; remaining >= 0; remaining -= 1) {
    frames.push({ remainingScoops: remaining, contact: true, durationMs: 260 });
  }
  return frames;
}
